import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { threadsBackend } from './threads.backend';
import { threadsReducer } from './threads.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('threads', threadsReducer),
    BackendModule.forFeature('threads', threadsBackend),
  ],
})
export class DatastoreThreadsModule {}



// WEBPACK FOOTER //
// ./src/@freelancer/datastore/threads/threads.module.ts